import { Component, effect, inject, input, OnChanges, output, signal, SimpleChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MenuLinkRapidiStore } from '../../store/menu-link-rapidi.store';
import { MenuObjInterface } from '../../models/interfaces/navbar.interface';



@Component({
  selector: 'app-navbar',
  imports: [RouterLink],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss',
})
export default class Navbar implements OnChanges {
  isSidebarOpen = signal<boolean>(false);
  isNavbarOpened = output<boolean>(); // usata in main layout
  closeNavbar = input<boolean>(false); // usata in main layout
  menuLinkRapidiStore = inject(MenuLinkRapidiStore);
  mergedMenu = signal<MenuObjInterface[]>([]);

  constructor() {
    effect(() => this.buildMergedMenu());
  }

  /**
   * Costruisce il menu finale (mergedMenu) combinando la configurazione statica (menu) con i dati dinamici (position) provenienti da menuLinkRapidiStore.
   * Per ogni voce dinamica, cerca la corrispondenza nella configurazione statica tramite il codice. Se trova una corrispondenza, crea un nuovo oggetto menu con le informazioni statiche e la posizione dinamica, e lo aggiunge al menu finale.
   * In questo modo si ottiene un menu che mantiene le informazioni di base definite staticamente, ma con l'ordine e la presenza delle voci gestite dinamicamente tramite il menuLinkRapidiStore.
   */
  private buildMergedMenu(): void {
    const voci = this.menuLinkRapidiStore.vociMenu() || [];
    const combined = voci.reduce<MenuObjInterface[]>((acc, voceDinamica) => {
      const match = this.menu.find(voceStatica => voceStatica.code === String(voceDinamica.code));
      if (!match) return acc;
      acc.push({
        code: match.code,
        id: voceDinamica.position,
        label: match.label,
        link: match.link,
        icon: match.icon,
        tooltip: match.tooltip
      });
      return acc;
    }, []).sort((a, b) => a.id - b.id);
    this.mergedMenu.set(combined);
    //* DEBUG
    // console.log('[SIDEBAR - mergedMenu]:', combined);
  }

  /**
   * La configurazione statica del menu, con le informazioni di base (label, link, icona, tooltip) per ogni voce.
   * Le voci dinamiche (position) vengono sovrascritte in mergedMenu tramite buildMergedMenu() in base ai dati del menuLinkRapidiStore.
   * In questo modo si mantiene una configurazione centralizzata e facilmente modificabile per le voci del menu, separando la logica di posizionamento dinamico.
   */
  readonly menu: MenuObjInterface[] = [
    {
      code: 'HOME',
      id: 1,
      label: 'Homepage',
      link: '/home',
      icon: 'assets/sidebar/home.svg',
      tooltip: 'Pagina iniziale con accesso rapido alle funzionalità principali'
      
    },
    {
      code: 'ASSEGNAZIONE',
      id: 2,
      label: 'Assegnazione',
      link: '/assegnazione',
      icon: 'assets/sidebar/assegnazioni.svg',
      tooltip: 'Gestione assegnazione degli adempimenti per ente ed esercizio contabile'
    },
    {
      code: 'ISTRUTTORIA',
      id: 3,
      label: 'Istruttoria',
      link: '/istruttoria',
      icon: 'assets/sidebar/istruttorie.svg',
      tooltip: 'Gestione e monitoraggio dei procedimenti istruttori'
    },
    {
      code: 'DOCUMENTI_ADEMPIMENTI',
      id: 4,
      label: 'Documenti',
      link: '/documenti-adempimenti',
      icon: 'assets/sidebar/documenti-adempimenti.svg',
      tooltip: 'Gestione Documenti adempimenti e allegati'
    },
    {
      code: 'QUESTIONARI',
      id: 5,
      label: 'Questionari',
      link: '/questionari',
      icon: 'assets/sidebar/questionari.svg',
      tooltip: 'Interrogazione dei questionari e dei relativi controlli'
    },
    {
      code: 'DOSSIER_ENTE',
      id: 6,
      label: 'Dossier Ente',
      link: '/dossier-ente',
      icon: 'assets/sidebar/dossier-ente.svg',
      tooltip: 'Fascicolo informativo dell\'ente'
    },
    {
      code: 'AGENDA',
      id: 7,
      label: 'Agenda',
      link: '/agenda',
      icon: 'assets/sidebar/agenda.svg',
      tooltip: 'Gestione delle convocazioni, calendario eventi e scadenze'
    },
    {
      code: 'SERVIZI_UTILI',
      id: 8,
      label: 'Servizi utili',
      link: '/servizi-utili',
      icon: 'assets/sidebar/servizi-utili.svg',
      tooltip: 'Strumenti di amministrazione del sistema'
    }
  ];


  ngOnChanges(simpleChanges: SimpleChanges): void {
    if (simpleChanges['closeNavbar']) {
      this.isSidebarOpen.set(simpleChanges['closeNavbar'].currentValue);
    }
  }

  toggleSidebar(item?: MenuObjInterface) {

    this.isSidebarOpen.set(!this.isSidebarOpen());
    this.isNavbarOpened.emit(this.isSidebarOpen());
  }

}
